export default "__VITE_ASSET__8047e50e__"